export default __webpack_public_path__ + "images/models/854415e5e683ec3240d2b1df1e687042.glb";